import { propFlipped } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import { toLower } from 'ramda'
import pipe from 'ramda/src/pipe'
import React from 'react'
import { toResourcePath } from '../../../../../utils/paths'
import Card from '../Card'
import Content from './Content'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const TYPE_ICON_MAPPING = {
  video: `fileVideo`,
  pdf: `filePdf`,
  audio: `fileAudio`,
}

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const getIconName = pipe(toLower, propFlipped(TYPE_ICON_MAPPING))

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const ResourceCard = ({ slug, title, authorName, type, image, isNew }) => {
  const iconName = getIconName(type)
  const url = toResourcePath(slug)
  return (
    <Card
      image={image}
      url={url}
      iconName={iconName}
      isNew={isNew}
      dataCy="resource-card"
    >
      <Content title={title} authorName={authorName} />
    </Card>
  )
}

ResourceCard.propTypes = {
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  authorName: PropTypes.string,
  image: PropTypes.object,
  type: PropTypes.string.isRequired,
  isNew: PropTypes.bool,
}

ResourceCard.defaultProps = {
  isNew: false,
  image: undefined,
  authorName: undefined,
}

export default ResourceCard
